import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute } from "@angular/router";
import { HealthService } from "../../core/services/health.service";
import { ConfigEntityService } from "../../core/services/config-entity.service";
import { NavigationService } from "../../core/services/navigation.service";

@Component({
  selector: "app-health",
  templateUrl: "./health.component.html",
  styleUrls: ["./health.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HealthComponent implements OnInit {
  data: any = {};
  sections: { section: string; values: any[] }[] = [];
  sec: string[] = ["System Details", "Services", "Network", "Log"];
  section: string;
  activeSection: any;
  currentActiveIndex: Number = 0;
  systemInfoDetails: any;
  metricsInfo: any;
  fileSystem: any;
  constructor(
    private healthService: HealthService,
    private route: ActivatedRoute,
    private configEntityService: ConfigEntityService,
    private navService: NavigationService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.healthService.activeHealthTab.subscribe((tab) => {
      this.activeSection = tab;
      if (this.sec.length > 0) {
        const indexNeeded = this.sec.findIndex(
          (el) => el === this.activeSection
        );
        if (indexNeeded >= 0) {
          this.focusOnTab(indexNeeded);
        }
      }
    });
    this.configEntityService.sendActiveEntity('Health');
    this.navService.sendChildData('Health');
    this.navService.sendParentData('');
    // this.healthService.getHostData().subscribe({
    //   next: (res) => {
    //     this.data = res;
    //     this.sections = this.getSections(res);
    //     if (!this.activeSection) {
    //     } else {
    //       let indexNeeded = this.sections.findIndex(
    //         (el) => el.section == this.activeSection
    //       );
    //       setTimeout(() => {
    //         this.focusOnTab(indexNeeded);
    //       }, 100);
    //     }
    //   },
    //   error: (err) => {
    //     console.error("Error fetching data", err);
    //   },
    // });
  }

  getAllHostHealthDetails() {
    this.healthService.getHostHealthInfoAll().subscribe({
      next: (data: any) => {
        this.sections = this.getSections(data);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
  loadDataAndUpdateSection(): void {
    this.healthService.getHostData().subscribe({
      next: (res) => {
        this.data = res;
        this.sections = this.getSections(res);
        const indexNeeded = this.sections.findIndex(
          (el) => el.section === this.activeSection
        );
        if (indexNeeded >= 0) {
          this.focusOnTab(indexNeeded);
        }
      },
      error: (err) => {
        console.error("Error fetching data", err);
      },
    });
  }

  focusOnTab(index: Number) {
    this.currentActiveIndex = index;
    this.cdRef.detectChanges();
  }
  isObject(value: any): boolean {
    return typeof value === "object" && value !== null && !Array.isArray(value);
  }

  getSections(obj: any): { section: string; values: any[] }[] {
    if (Array.isArray(obj)) {
      return [{ section: "array", values: obj }];
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).map((key) => ({
        section: key,
        values: Array.isArray(obj[key]) ? obj[key] : [obj[key]],
      }));
    } else {
      return [];
    }
  }

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  isStatusActive(status: string): boolean {
    return status === "Active";
  }
}
